<template>
  <div class="p-4">
    <l-l-selection class="mb-4" :networks="networks" @click="onSelectionClick" />
    <l-l-chart ref="chart" v-show="showChart" />

    <l-info-box class="mb-4" :active="dataset.length > 0">Select row number(s) in table below and right click to validate values, or click on the bars in the graph above for setting the values as not valid!</l-info-box>
    <hot-table :data="dataset" :settings="settings" v-show="dataset.length > 0" ref="hot">
      <hot-column title="Station" data="station" read-only="true"></hot-column>
      <hot-column title="Pollutant" data="pollutant" read-only="true"></hot-column>        
      <hot-column title="From" data="from" read-only="true"></hot-column>
      <hot-column title="To" data="to" read-only="true"></hot-column>
      <hot-column title="Value" data="value" read-only="true" type="numeric" :renderer="validRenderer"></hot-column>              
      <hot-column title="Validation" data="validation_flag" read-only="true" type="numeric" :renderer="validRenderer"></hot-column>  
      <hot-column title="Verification" data="verification_flag" read-only="true" type="numeric"></hot-column>        
    </hot-table>
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import LLSelection from "./LLSelection";

import LLChart from "./LLChartValidate";
import HistoricalService from "@/helpers/services/viewer/historical.service";

import ValidateService from "@/helpers/services/qualitycontrol/validate.service";
import Notify from "@/helpers/notify";

import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";

import LInfoBox from "@/components/LInfoBox";

export default {
  name: "Validate",
  components: {
    LLSelection,
    LLChart,
    HotTable,
    HotColumn,
    LInfoBox
  },
  data() {
    return {
      dataset: [],
      showChart:false,    
      networks: [],
      settings: HandsontableHelper.settings(false)
    };
  },
  mounted() {
    this.settings.columnSorting = false;
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData(null, this.loadInitialData);
  },
  methods: {
    async loadInitialData() {
      this.networks = await ValidateService.networks();
    },
    onSelectionClick(selection) {
      Notify.loadData(
        null,
        this.loadDataset,
        selection.id,
        selection.from,
        selection.to
      );
    },
    async loadDataset(id, from, to) {
      // Add data to graph
      this.showChart = true;
      this.$refs.chart.removeSeries();
      const series = await ValidateService.observations(id, from, to, true, true);
      this.$refs.chart.addSeries(series);

      // Add data to grid 
      this.dataset = [];
      this.dataset = await ValidateService.dataset(id, from, to);
    },
    validRenderer(instance, td, row, col, prop, value, cellProperties) {
      Handsontable.renderers.TextRenderer.apply(this, arguments);
      const rowData = instance.getSourceDataAtRow(cellProperties.row);
      if (rowData.validation_flag < 0) {
        td.className = "htRight htMiddle text-red-700 font-bold text-md";
      } else {
        td.className = "htRight htMiddle text-green-700 font-medium";
      }
    },
    async updateValidationFlag(flag, rowsCollection) {
      const hot = this.$refs.hot.hotInstance;
      // debugger
      const rowsToValidate = [];
      rowsCollection.forEach(rows => {
        for (let i = rows.start.row; i < rows.end.row + 1; i++) {
          const physicalIndex = hot.toPhysicalRow(i);
          let row = hot.getSourceDataAtRow(physicalIndex);
          rowsToValidate.push({ id: row.id, flag: flag, index: physicalIndex });
        }
      });
      Notify.loadData(
        "Please wait while validating data",
        this.updateValidationFlagOnGrid,
        flag,
        rowsToValidate
      );
    },
    async updateValidationFlagOnGrid(flag, rowsToValidate) {
      const rowsUpdated = await ValidateService.validate(rowsToValidate);
      const hot = this.$refs.hot.hotInstance;
      const activeEditor = hot.getActiveEditor();
      rowsToValidate.forEach(r => {
        hot.setDataAtRowProp([[r.index, "validation_flag", flag]]);
      });
    }
  }
};
</script>